import { getStoreId } from "$/hooks/use-store-information"
import reviewQueries from "$/lib/queries/review-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/reviews")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(reviewQueries.list({ storeId }))

    return {
      crumb: "alfred.pages.reviews.crumbs.reviews",
    }
  },
})
